import 'core-js/es';
import inView from 'in-view';

import React, { useEffect, useMemo, useState } from 'react';
import './App.scss';
import { AppContext } from './Context';
import { useWindowSize } from './helpers';
import * as Sections from './sections';
import Stickyfill from 'stickyfilljs'

// check_webp_feature:
//   'feature' can be one of 'lossy', 'lossless', 'alpha' or 'animation'.
//   'callback(feature, result)' will be passed back the detection result (in an asynchronous way!)
function check_webp_feature(feature, callback) {
  var kTestImages = {
    lossy: 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA',
    lossless: 'UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==',
    alpha: 'UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==',
    animation: 'UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA'
  };
  var img = new Image();
  img.onload = function() {
    var result = img.width > 0 && img.height > 0;
    callback(feature, result);
  };
  img.onerror = function() {
    callback(feature, false);
  };
  img.src = 'data:image/webp;base64,' + kTestImages[feature];
}


function removeClass(ele,txt){
  var str =  ele.className,
      index = str.indexOf(txt);
  if(index > -1){
    ele.className = str.replace(txt,"");
  }
}

setTimeout(function () {

    // Sticky polyfill
    var stickyElements = document.querySelectorAll('.sticky-content');
    Stickyfill.add(stickyElements);

    // Background lazyLoad
    inView('.lazyBackground').on('enter',  function (ele) {
      removeClass(ele,'lazyBackground');
    });
  }
);

function App() {
  const size = useWindowSize();

  const [isAndroid, setIsAndroid] = useState(false);
  const [webpSupport, setWebpSupport] = useState();
  useEffect(() => {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) {
      setWebpSupport(false);
      return;
    }
    check_webp_feature('lossy', result => setWebpSupport(result));
  }, [setWebpSupport]);

  useEffect(() => {
    const isAndroid = /Android/.test(navigator.userAgent);
    if (isAndroid) {
      setIsAndroid(true);
    }
  }, []);

  const mobile = useMemo(() => size.width <= 750, [size]);
  return (
    <AppContext.Provider
      value={{
        webpSupport,
        webpDetectionFinished: webpSupport !== undefined
      }}
    >
      <div className="App">
        <Sections.HeroPlus mobile={mobile} />
        <Sections.Briefing />
        <Sections.Appearance mobile={mobile} />
        <Sections.CameraBrief mobile={mobile} />
        <Sections.CameraLens1 mobile={mobile} />
        <Sections.CameraLens2 mobile={mobile} />
        <Sections.CameraNightBrief mobile={mobile} />
        <Sections.CameraNight1 mobile={mobile} />
        <Sections.CameraNight2 mobile={mobile} />
        <Sections.SuperLens />
        <Sections.CameraMotionShot />
        <Sections.VideoBrief />
        <Sections.SmartShotIntro mobile={mobile} />
        <Sections.HighZoom mobile={mobile} />
        <Sections.Portrait1 mobile={mobile} />
        {!mobile && <Sections.Portrait2 />}
        {mobile && <Sections.Portrait3 />}
        {mobile && <Sections.Portrait4 />}
        <Sections.Section15 mobile={mobile} />
        <Sections.CPUBrief mobile={mobile} />
        <Sections.CPU1 mobile={mobile}/>
        <Sections.HighRefreshRate2 mobile={mobile} />
        <Sections.LTM mobile={mobile} />
        <Sections.GamePlay mobile={mobile} />
        <Sections.GamePlay2 mobile={mobile} />
        <Sections.Charging mobile={mobile} />
        <Sections.Sound mobile={mobile} />
        <Sections.OS />
        <Sections.DesktopB mobile={mobile} />
        <Sections.MotionWallpaper />
        <Sections.CameraCloseUp mobile={mobile} />
        <Sections.Doc mobile={mobile} />
        <Sections.Remarks />
        <Sections.SaleAd />
      </div>
    </AppContext.Provider>
  );
}

export default App;
